import { Component, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { SelfcorrectingService } from '../selfcorrecting.service';
import { GeneralTeacherComponent } from '../../General/gt.component';

@Component({
  selector: 'app-t-reverse-bit',
  templateUrl: './t-reverse-bit.component.html',
  styleUrls: ['./t-reverse-bit.component.css']
})
export class TReverseBitComponent extends GeneralTeacherComponent {
  message: string;
  dimension: number[] = [0, 0];
  modus: string;
  encoding: string = "cardTrick";
  highlight: boolean = false;
  useSymbols: boolean = false;

  length: number;
  hamming: string;

  showMessage: string;

  messageArray: number[][] = [];

  writeManually: boolean = false;

  c: number[] = [];
  p: string[] = [];

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService, protected selfcorrectingService: SelfcorrectingService) {
    super(topicService, activatedRoute);
    this.type = "reverseBit";
    this.title = this.get("reverseBit");
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.message = this.configuration.typespecifics.message;
    console.log(this.message);
    this.dimension = this.configuration.typespecifics.dimension ? this.configuration.typespecifics.dimension : [];
    this.modus = this.configuration.typespecifics.modus;
    this.encoding = this.configuration.typespecifics.encoding;
    this.highlight = this.configuration.typespecifics.highlight;
    this.useSymbols = this.configuration.typespecifics.useSymbols;


    this.message = this.selfcorrectingService.reconstruct(this.message, this.encoding, this.dimension);
    console.log(this.message);
    this.computeShowMessage();



    if (this.encoding == "cardTrick") {
      this.message = this.message.substr(0, this.message.length - this.dimension[0] - this.dimension[1] - 1);
    } else {
      this.message = this.message.split("").filter((v, i) => !this.powerOfTwo(i + 1)).join("");
    }



    if (this.encoding == "cardTrick") {
      this.fillArray();
    }
    this.changeMessage();

  }

  generateDefinition() {
    let definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/reverseCard.png";
    definition.level = 1;
    definition.key = "selfcorrecting%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    if (this.encoding == 'cardTrick') {
      let index = Math.floor(Math.random() * this.dimension[0] * this.dimension[1]);
      definition.typespecifics.message = this.message.substr(0, index).concat((1 - +this.message.charAt(index)).toString(), this.message.substr(index + 1, this.message.length), this.c.join(""));
      definition.typespecifics.dimension = this.dimension;
    } else {
      let index = Math.ceil(Math.random() * 15);
      let paritiyI = 0;
      let dataI = 0;
      definition.typespecifics.message = "";
      for (let i = 1; i < this.message.length + 5; i++) {
        if (this.powerOfTwo(i)) {
          if (i != index) {
            definition.typespecifics.message = definition.typespecifics.message.concat(this.c[paritiyI]);
          } else {
            definition.typespecifics.message = definition.typespecifics.message.concat((1 - +this.c[paritiyI]).toString());
          }
          paritiyI++;
        } else {
          if (i != index) {
            definition.typespecifics.message = definition.typespecifics.message.concat(this.message.charAt(dataI));
          } else {
            definition.typespecifics.message = definition.typespecifics.message.concat((1 - +this.message.charAt(dataI)).toString());
          }
          dataI++;
        }
      }
    }
    definition.typespecifics.modus = this.modus;
    definition.typespecifics.encoding = this.encoding;
    definition.typespecifics.highlight = this.highlight;
    definition.typespecifics.useSymbols = this.modus == "reversedCard" && this.encoding == 'cardTrick'?this.useSymbols:false;
    if (this.encoding == "cardTrick") {
      definition.key = definition.key.concat("%", this.message, "%", this.encoding.toString(), "%", this.dimension.toString(), "%", definition.typespecifics.modus.toString());
    } else {
      definition.key = definition.key.concat("%", this.message, "%", this.encoding.toString(), "%", definition.typespecifics.modus.toString());
    }

    return definition;

  }

  generate(){
    this.title = this.get("reverseBit");
    this.encoding = "cardTrick";
    this.dimension[0] = Math.ceil(Math.random() * 5);
    this.dimension[1] = Math.ceil(Math.random() * 5);
    this.message = this.generate01(this.dimension[0]*this.dimension[1])
    this.modus = Math.random() > 0.5?'reversedCard':'correctMessage';
    this.highlight = true;
    this.computeShowMessage();

    if (this.encoding == "cardTrick") {
      this.fillArray();
    }
    this.changeMessage();
    this.computeLength();
  }

  /** generates a 01-string of given length
   * @param length -  length of string to generate
   */
  generate01(length: number){
    let result = "";
    for(let i = 0; i < length; i++){
      result = result.concat((Math.random() > 0.5?"0":"1"));
    }
    return result;
  }

  /** recomputes the message array */
  changeDimension() {
    this.message = this.messageArray.map(v => v.join("")).join("");
    this.messageArray = [];
    let index = 0;
    for (let i = 0; i < this.dimension[0]; i++) {
      let elem = [];
      for (let j = 0; j < this.dimension[1]; j++) {
        elem[j] = this.message.charAt(index);
        index++;
      }
      this.messageArray.push(elem);
    }
    this.length = this.dimension[0] * this.dimension[1];
  }

  /** fills the message array based in the message */
  fillArray() {
    if (this.encoding == "cardTrick") {
      this.messageArray = [];
      let index = 0;
      for (let i = 0; i < this.dimension[0]; i++) {
        let elem = [];
        for (let j = 0; j < this.dimension[1]; j++) {
          elem[j] = this.message.charAt(index);
          index++;
        }
        this.messageArray.push(elem);
      }
    }
  }

  /** normalizes the message */
  normalize(s: string): string {
    if (!s) {
      return "";
    }
    return s.replace(/[^01]/, "");
  }

  /** computes the comtrol bits */
  changeMessage() {
    if (this.encoding == "cardTrick") {
      this.controlBits()
    } else {
      this.computeShowMessage();
      this.hammingCode();
    }
  }

  /** computes the comtrolbits for the card trick */
  controlBits() {
    this.c = this.selfcorrectingService.controlBits(this.messageArray, this.dimension);
    this.message = this.messageArray.map(v => v.join("")).join("");
  }

  /** computes the haming code */
  hammingCode() {
    this.length = 11;
    this.p[0] = "";
    this.p[1] = "";
    this.p[2] = "";
    this.p[3] = "";
    for (let i of this.selfcorrectingService.allCodes(4)) {
      if (i != "0000" && !this.powerOfTwo(parseInt(i, 2))) {
        for (let j = 0; j < 4; j++) {
          if (i.charAt(j) == "1") {
            this.p[3 - j] = this.p[3 - j].concat(this.showMessage.charAt(parseInt(i, 2) - 1), " ");
          }
        }
      }
    }
    this.c = this.p.map(v => v.split("").map(v => +v).reduce((a, b) => a + b, 0)).map(v => v % 2);
  }

  /** converts a number into a code
   * @param i - number to convert
   * @param length - length of code
   */
  toString(i: number, length: number) {
    return "0".repeat(length).concat(i.toString(2)).slice(-length);
  }

  /** computes the expected length of the message */
  computeLength() {
    if (this.encoding == "cardTrick") {
      this.length = this.dimension[0] * this.dimension[1];
    } else {
      this.length = 11;
    }
  }

  /** checks whether the given number is a power of 2
   * @param x - number to check
   */
  powerOfTwo(x: number): boolean {
    return (Math.log(x) / Math.log(2)) % 1 === 0
  }

  /**
   * computes 2^i
   * @param i - power
   */
  pow2(i: number): number {
    return Math.pow(2, i);
  }

  /**
   * computes the message to show
   */
  computeShowMessage() {
    let dataI = 0;
    let parityI = 0;
    this.showMessage = "";
    for (let i = 1; i < 16; i++) {
      if (this.powerOfTwo(i)) {
        if (this.c[parityI] != undefined && this.c[parityI].toString() != "") {
          this.showMessage = this.showMessage.concat(this.c[parityI].toString());
        } else {
          this.showMessage = this.showMessage.concat("c");
        }
        parityI ++;
      } else {
        this.showMessage = this.showMessage.concat(this.message.charAt(dataI));
        dataI++;
      }
    }
  }

  reset() {
    super.reset();
    this.title = this.get("reverseBit");
    this.message = undefined;
    this.dimension = [0, 0];
    this.modus = undefined;
    this.encoding = "cardTrick";
    this.useSymbols = false;
    this.highlight = false;


  }
}
